<div
  #wrapper
  libSwipe
  swipeAxis="horizontal"
  class="notification-wrapper relative flex max-w-[22.5rem] overflow-hidden rounded-lg bg-grey-100 py-2 pl-4 pr-2 shadow-[0px_4px_25px_0px_rgba(0,0,0,0.5)] transition-transform dark:bg-grey-550 max-sm:border-b sm:border-l"
  [class]="type()"
  (mouseenter)="onPause()"
  (mouseleave)="onResume()"
  (swipeLeft)="onSwipe(ESwipeDirection.Left)"
  (swipeRight)="onSwipe(ESwipeDirection.Right)"
>
  <div class="notification-icon flex items-start pt-0.5">
    <i class="{{ icon() }} text-xl/5"></i>
  </div>

  <div class="flex w-full flex-col pl-3 pr-2">
    @let key = 'COMMON.' + (type() | uppercase);
    <div class="text-base font-bold text-grey-600 dark:text-grey-100">{{ key | transloco }}</div>

    <div
      class="whitespace-pre-line text-sm font-normal text-grey-400 dark:text-grey-300"
      [innerHTML]="text()"
    ></div>
  </div>

  <i
    class="ph ph-x cursor-pointer text-base/4"
    (click)="close()"
  ></i>

  <!--лоадер-->
  <div
    class="absolute bottom-0 right-0 h-1 bg-green-900 transition-all"
    [style.width]="lifeTimeProgress() + '%'"
  ></div>
</div>
